export default __webpack_public_path__ + "navigation-overview-setup-ib-1200-6ba9fe04fe93e50dab52537f838156e2.webp";